<div *ngIf="!loading">
  <div class="spinner"></div>
  <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
  </p>
</div>

<div *ngIf="loading" class="animated fadeIn">
  <div class="timeline-body">
    <div class="form-group">
      <label for="imput14">4.1 – Quais Técnicas de Monitoramento e Avaliação serão aplicadas durante a execução do objeto:</label>
      <p class="help-block">Indicar quais são as técnicas, quando serão aplicadas, e quais os objetivos da aplicação e quais os possíveis
        encaminhamentos que serão adotados com base nas informações obtidas durante o monitoramento e avaliação</p>
      <textarea [(ngModel)]="monitoramentoAvaliacao.tecnicaMonitoramento" class="form-control" rows="3" id="imput14"></textarea>
    </div>
    <div class="form-group">
      <label for="imput15">4.2 – Sustentabilidade da Proposta:</label>
      <p class="help-block">(Indicar se as ações/atividades terão continuidade após o término da vigência deste Termo ou quais estratégias
        serão utilizadas para garantir a continuidade das ações/atividades</p>
      <textarea [(ngModel)]="monitoramentoAvaliacao.sustentabilidadeProposta" class="form-control" rows="3" id="imput15"></textarea>
    </div>
  </div>

  <div class="timeline-footer" >
    <a class="btn btn-primary btn-sm" (click)="modificaMonitoramentoAvaliacao()">Realizar ajuste</a>
  </div>
</div>